/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * ``POST /inbox/threads/{thread_id}/auto-draft/regenerate`` body.
 */
export interface AutoDraftRegenerateRequest {
  custom_instructions?: string | null;
}
